import { useCallback, useState } from "react";

export function useHoverLens(
  activeImgRef: React.RefObject<HTMLImageElement>,
  lensSize: number,
  zoom: number,
  previewDims?: { width: number; height: number },
) {
  const [showLens, setShowLens] = useState(false);
  const [lensPos, setLensPos] = useState<{ x: number; y: number }>({
    x: 0,
    y: 0,
  });
  const [lensBg, setLensBg] = useState<{ size: string; position: string }>({
    size: "0px 0px",
    position: "0px 0px",
  });
  const [previewBg, setPreviewBg] = useState<{
    size: string;
    position: string;
  }>({ size: "0px 0px", position: "0px 0px" });

  const onLensEnter = useCallback(() => setShowLens(true), []);
  const onLensLeave = useCallback(() => setShowLens(false), []);

  const onLensMove: React.MouseEventHandler<HTMLDivElement> = useCallback(
    (e) => {
      const img = activeImgRef.current;
      if (!img) return;
      const imgRect = img.getBoundingClientRect();
      const containerRect = (
        e.currentTarget as HTMLDivElement
      ).getBoundingClientRect();

      const x = Math.max(0, Math.min(e.clientX - imgRect.left, imgRect.width));
      const y = Math.max(0, Math.min(e.clientY - imgRect.top, imgRect.height));

      setLensPos({
        x: e.clientX - containerRect.left - lensSize / 2,
        y: e.clientY - containerRect.top - lensSize / 2,
      });

      const bgW = imgRect.width * zoom;
      const bgH = imgRect.height * zoom;
      const bgX = -(x * zoom - lensSize / 2);
      const bgY = -(y * zoom - lensSize / 2);
      setLensBg({ size: `${bgW}px ${bgH}px`, position: `${bgX}px ${bgY}px` });

      if (previewDims && previewDims.width > 0 && previewDims.height > 0) {
        const pX = -(x * zoom - previewDims.width / 2);
        const pY = -(y * zoom - previewDims.height / 2);
        setPreviewBg({
          size: `${bgW}px ${bgH}px`,
          position: `${pX}px ${pY}px`,
        });
      }
    },
    [activeImgRef, lensSize, zoom, previewDims],
  );

  return {
    showLens,
    lensPos,
    lensBg,
    previewBg,
    onLensEnter,
    onLensLeave,
    onLensMove,
  };
}
